import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { APPOINTMENT_TABS } from '../constants';
import { useAppointmentAnalyticsV2ShallowStore } from '../hooks/use-appointment-analytics-v2-store';
import { AppointmentLocationFilter } from './filters/appointment-location-filter';
import { AppointmentTimePeriodFilter } from './filters/appointment-time-period-filter';

export interface CompareLocationsFiltersProps {
  filters: {
    locationId?: string[];
    startDate?: string;
    endDate?: string;
  };
  onChange: (filters: { locationId?: string[]; startDate?: string; endDate?: string }) => void;
  setFilterHintText: (text: string) => void;
}

export const CompareLocationsFilters = ({ filters, onChange, setFilterHintText }: CompareLocationsFiltersProps) => {
  const { activeTab } = useAppointmentAnalyticsV2ShallowStore('activeTab');

  const updateAppliedFilter = (updatedFilters: Partial<typeof filters>) => {
    onChange({ ...filters, ...updatedFilters });
  };

  return (
    <div css={styles.container}>
      <div css={styles.filtersWrapper}>
        <AppointmentLocationFilter
          value={filters.locationId}
          onChange={(locationId) => updateAppliedFilter({ locationId })}
        />

        <AppointmentTimePeriodFilter
          activeTab={activeTab}
          upcomingDates={activeTab === APPOINTMENT_TABS.UPCOMING ? filters : {}}
          pastDates={activeTab === APPOINTMENT_TABS.PAST ? filters : {}}
          locationId={filters.locationId}
          setFilterHintText={setFilterHintText}
          onChange={(dates) => updateAppliedFilter(dates)}
        />
      </div>
    </div>
  );
};

const styles = {
  container: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
  `,
  filtersWrapper: css`
    display: flex;
    gap: ${theme.spacing(2)};
    align-items: center;
  `,
};
